import React from 'react';

import {
    Box,
    FormControl,
    MenuItem,
    Pagination,
    Select,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const BasicPagination = ({
    customContent,
    onChangePage,
    onChangePageSize,
    page,
    pageCount,
    pageSize,
    pageSizeOptions,
    rowCount,
}) => {
    const { t } = useTranslation();
    const sxBox = {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
    };
    const sxWrapper = {
        alignItems: 'center',
        display: 'flex',
        flexDirection: { md: 'row', xs: 'column' },
        gap: 1,
        mx: 2,
        width: '100%',
    };

    return (
        <Box sx={sxWrapper}>
            {customContent && <Box sx={{ ...sxBox }}>{customContent}</Box>}

            <Box sx={{ ...sxBox, ml: { md: 'auto', xs: 1 } }}>
                <Typography fontWeight="bold" noWrap variant="body2">
                    {t('Total rows')}:
                </Typography>
                {rowCount}
            </Box>

            {pageSizeOptions?.length > 0 && (
                <Box sx={sxBox}>
                    <Typography fontWeight="bold" noWrap variant="body2">
                        {t('Rows per page')}:
                    </Typography>

                    <FormControl size="small">
                        <Select
                            onChange={(event) =>
                                onChangePageSize(event?.target?.value)
                            }
                            sx={{ textAlign: 'center' }}
                            value={pageSize}
                        >
                            {pageSizeOptions.map((option) => (
                                <MenuItem
                                    key={`option-${option}`}
                                    value={option}
                                >
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            )}

            <FormControl sx={{ m: 1 }}>
                <Pagination
                    color="primary"
                    count={pageCount}
                    onChange={(_, value) => onChangePage(value - 1)}
                    page={page + 1}
                    size="small"
                />
            </FormControl>
        </Box>
    );
};

BasicPagination.propTypes = {
    customContent: PropTypes.node,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    page: PropTypes.number,
    pageCount: PropTypes.number,
    pageSize: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    rowCount: PropTypes.number,
};

export default BasicPagination;
